import { useSelector } from 'react-redux';

export const useRole = () => {
    const roleObject = useSelector(state => state.Auth.role) ?? {};
    const role = Object.keys(roleObject)[0] * 1;
    return role;
}